export const interpreters = [
  {
    label: "Abul",
    value: 0
  },
  {
    label: "Babul",
    value: 1
  },
  {
    label: "Karim",
    value: 2
  }
]

export const genders = [
  {
    label: "Any",
    value: 0
  },
  {
    label: "Male",
    value: 1
  },
  {
    label: "Female",
    value: 2
  }
]
export const filterGenders = [
  {
    label: "Any",
    value: ""
  },
  {
    label: "Male",
    value: 1
  },
  {
    label: "Female",
    value: 2
  }
]

export const Statuses = [
  {
    label: 'Any',
    value: ''
  },
  {
    label: "Open",
    value: 1
  },
  {
    label: "Offered",
    value: 2
  },
  {
    label: "Confirmed",
    value: 3
  },
  {
    label: "Billed",
    value: 4
  },
  {
    label: "Paid",
    value: 5
  },
  {
    label: "Closed",
    value: 6
  },
  {
    label: "Cancelled",
    value: 7
  },
  {
    label: "Unfulfilled",
    value: 8
  },
  {
    label: "NoShow",
    value: 9
  }
]
export const callStatues = [
  {
    label: 'Any',
    value: ""
  },
  {
    label: "Missed",
    value: "3"
  },
  {
    label: "Rejected",
    value: "4"
  },
  {
    label: "Completed",
    value: "8"
  },
  {
    label: "Operator Not Found",
    value: "26"
  },
  {
    label: "VRI Operator Not Found",
    value: "31"
  },
  {
    label: "Abandoned Auth Failure",
    value: "29"
  },
  {
    label: "Abandoned Language Failure",
    value: "30"
  },
]
export const callStatuses = [
  {
    label: 'Any',
    value: 0
  },
  {
    label: "Initiated",
    value: 1
  },
  {
    label: "Ringing",
    value: 2
  },
  {
    label: "Missed",
    value: 3
  },
  {
    label: "Rejected",
    value: 4
  },
  {
    label: "Received",
    value: 5
  },
  {
    label: "Established",
    value: 6
  },
  {
    label: "Failed",
    value: 7
  },
  {
    label: "Canceled",
    value: 8
  },
  {
    label: "Abort",
    value: 9
  },
  {
    label: "Participant Invited",
    value: 10
  },
  {
    label: "Participant Rejected",
    value: 11
  },
  {
    label: "Participant Missed",
    value: 12
  },
  {
    label: "Participant Joined",
    value: 13
  },
  {
    label: "Participant Left",
    value: 14
  },
  {
    label: "Preparing Call Summary",
    value: 15
  },
  {
    label: "Searching",
    value: 16
  },
  {
    label: "Operator Not Found",
    value: 17
  },
  {
    label: "User Not Found",
    value: 18
  },

]

export const AuditLogSelectOption = [
  {
    label: "Any",
    value: 0
  },
  {
    label: "Add User",
    value: 1
  },
  {
    label: "Delete User",
    value: 2
  },
  {
    label: "Add Company",
    value: 3
  },
  {
    label: "Delete Company",
    value: 4
  },
  {
    label: "Make Payment To Operator",
    value: 5
  },
  {
    label: "Get Payment From Company",
    value: 6
  },
  {
    label: "Add Operator",
    value: 7
  },
  {
    label: "Delete Operator",
    value: 8
  }
]

export const ActivitySelectOption = [
  {
    label: "Any",
    value: 0
  },
  {
    label: "Online",
    value: 1
  },
  {
    label: "Offline",
    value: 2
  },
  {
    label: "Call Received",
    value: 3
  },
  {
    label: "Call Missed",
    value: 4
  },
  {
    label: "Call Ignored",
    value: 5
  },
  {
    label: "Call Ended",
    value: 6
  },
  {
    label: "Login",
    value: 7
  },
  {
    label: "Logout",
    value: 8
  },
  {
    label: "Participant Joined",
    value: 9
  },
  {
    label: "Participant Left",
    value: 10
  },
  {
    label: "Connection Lost",
    value: 14
  }
]

export const StatusSelectOption = [
  { label: "Any", value: 0 },
  { label: 'Online', value: 1 },
  { label: 'In Call', value: 3 },
  { label: 'Busy', value: 11 }
];

// export const timeZones = [
//   {
//     value: "Dateline Standard Time",
//     "abbr": "DST",
//     "offset": -12,
//     "isdst": false,
//     label: "(UTC-12:00) International Date Line West",
//     utc: [
//       "Etc/GMT+12"
//     ]
//   },
//   {
//     value: "UTC-11",
//     "abbr": "U",
//     "offset": -11,
//     "isdst": false,
//     label: "(UTC-11:00) Coordinated Universal Time-11",
//     utc: [
//       "Etc/GMT+11",
//       "Pacific/Midway",
//       "Pacific/Niue",
//       "Pacific/Pago_Pago"
//     ]
//   },
//   {
//     value: "Hawaiian Standard Time",
//     "abbr": "HST",
//     "offset": -10,
//     "isdst": false,
//     label: "(UTC-10:00) Hawaii",
//     utc: [
//       "Etc/GMT+10",
//       "Pacific/Honolulu",
//       "Pacific/Johnston",
//       "Pacific/Rarotonga",
//       "Pacific/Tahiti"
//     ]
//   },
//   {
//     value: "Alaskan Standard Time",
//     "abbr": "AKDT",
//     "offset": -8,
//     "isdst": true,
//     label: "(UTC-09:00) Alaska",
//     utc: [
//       "America/Anchorage",
//       "America/Juneau",
//       "America/Nome",
//       "America/Sitka",
//       "America/Yakutat"
//     ]
//   },
//   {
//     value: "Pacific Standard Time (Mexico)",
//     "abbr": "PDT",
//     "offset": -7,
//     "isdst": true,
//     label: "(UTC-08:00) Baja California",
//     utc: [
//       "America/Santa_Isabel"
//     ]
//   },
//   {
//     value: "Pacific Daylight Time",
//     "abbr": "PDT",
//     "offset": -7,
//     "isdst": true,
//     label: "(UTC-07:00) Pacific Time (US & Canada)",
//     utc: [
//       "America/Los_Angeles",
//       "America/Tijuana",
//       "America/Vancouver"
//     ]
//   },
//   {
//     value: "Pacific Standard Time",
//     "abbr": "PST",
//     "offset": -8,
//     "isdst": false,
//     label: "(UTC-08:00) Pacific Time (US & Canada)",
//     utc: [
//       "America/Los_Angeles",
//       "America/Tijuana",
//       "America/Vancouver",
//       "PST8PDT"
//     ]
//   },
//   {
//     value: "US Mountain Standard Time",
//     "abbr": "UMST",
//     "offset": -7,
//     "isdst": false,
//     label: "(UTC-07:00) Arizona",
//     utc: [
//       "America/Creston",
//       "America/Dawson",
//       "America/Dawson_Creek",
//       "America/Hermosillo",
//       "America/Phoenix",
//       "America/Whitehorse",
//       "Etc/GMT+7"
//     ]
//   },
//   {
//     value: "Mountain Standard Time (Mexico)",
//     "abbr": "MDT",
//     "offset": -6,
//     "isdst": true,
//     label: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
//     utc: [
//       "America/Chihuahua",
//       "America/Mazatlan"
//     ]
//   },
//   {
//     value: "Mountain Standard Time",
//     "abbr": "MDT",
//     "offset": -6,
//     "isdst": true,
//     label: "(UTC-07:00) Mountain Time (US & Canada)",
//     utc: [
//       "America/Boise",
//       "America/Cambridge_Bay",
//       "America/Denver",
//       "America/Edmonton",
//       "America/Inuvik",
//       "America/Ojinaga",
//       "America/Yellowknife",
//       "MST7MDT"
//     ]
//   },
//   {
//     value: "Central America Standard Time",
//     "abbr": "CAST",
//     "offset": -6,
//     "isdst": false,
//     label: "(UTC-06:00) Central America",
//     utc: [
//       "America/Belize",
//       "America/Costa_Rica",
//       "America/El_Salvador",
//       "America/Guatemala",
//       "America/Managua",
//       "America/Tegucigalpa",
//       "Etc/GMT+6",
//       "Pacific/Galapagos"
//     ]
//   },
//   {
//     value: "Central Standard Time",
//     "abbr": "CDT",
//     "offset": -5,
//     "isdst": true,
//     label: "(UTC-06:00) Central Time (US & Canada)",
//     utc: [
//       "America/Chicago",
//       "America/Indiana/Knox",
//       "America/Indiana/Tell_City",
//       "America/Matamoros",
//       "America/Menominee",
//       "America/North_Dakota/Beulah",
//       "America/North_Dakota/Center",
//       "America/North_Dakota/New_Salem",
//       "America/Rainy_River",
//       "America/Rankin_Inlet",
//       "America/Resolute",
//       "America/Winnipeg",
//       "CST6CDT"
//     ]
//   },
//   {
//     value: "Central Standard Time (Mexico)",
//     "abbr": "CDT",
//     "offset": -5,
//     "isdst": true,
//     label: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
//     utc: [
//       "America/Bahia_Banderas",
//       "America/Cancun",
//       "America/Merida",
//       "America/Mexico_City",
//       "America/Monterrey"
//     ]
//   },
//   {
//     value: "Canada Central Standard Time",
//     "abbr": "CCST",
//     "offset": -6,
//     "isdst": false,
//     label: "(UTC-06:00) Saskatchewan",
//     utc: [
//       "America/Regina",
//       "America/Swift_Current"
//     ]
//   },
//   {
//     value: "SA Pacific Standard Time",
//     "abbr": "SPST",
//     "offset": -5,
//     "isdst": false,
//     label: "(UTC-05:00) Bogota, Lima, Quito",
//     utc: [
//       "America/Bogota",
//       "America/Cayman",
//       "America/Coral_Harbour",
//       "America/Eirunepe",
//       "America/Guayaquil",
//       "America/Jamaica",
//       "America/Lima",
//       "America/Panama",
//       "America/Rio_Branco",
//       "Etc/GMT+5"
//     ]
//   },
//   {
//     value: "Eastern Standard Time",
//     "abbr": "EDT",
//     "offset": -4,
//     "isdst": true,
//     label: "(UTC-05:00) Eastern Time (US & Canada)",
//     utc: [
//       "America/Detroit",
//       "America/Havana",
//       "America/Indiana/Petersburg",
//       "America/Indiana/Vincennes",
//       "America/Indiana/Winamac",
//       "America/Iqaluit",
//       "America/Kentucky/Monticello",
//       "America/Louisville",
//       "America/Montreal",
//       "America/Nassau",
//       "America/New_York",
//       "America/Nipigon",
//       "America/Pangnirtung",
//       "America/Port-au-Prince",
//       "America/Thunder_Bay",
//       "America/Toronto",
//       "EST5EDT"
//     ]
//   },
//   {
//     value: "US Eastern Standard Time",
//     "abbr": "UEDT",
//     "offset": -4,
//     "isdst": true,
//     label: "(UTC-05:00) Indiana (East)",
//     utc: [
//       "America/Indiana/Marengo",
//       "America/Indiana/Vevay",
//       "America/Indianapolis"
//     ]
//   },
//   {
//     value: "Venezuela Standard Time",
//     "abbr": "VST",
//     "offset": -4.5,
//     "isdst": false,
//     label: "(UTC-04:30) Caracas",
//     utc: [
//       "America/Caracas"
//     ]
//   },
//   {
//     value: "Paraguay Standard Time",
//     "abbr": "PYT",
//     "offset": -4,
//     "isdst": false,
//     label: "(UTC-04:00) Asuncion",
//     utc: [
//       "America/Asuncion"
//     ]
//   },
//   {
//     value: "Atlantic Standard Time",
//     "abbr": "ADT",
//     "offset": -3,
//     "isdst": true,
//     label: "(UTC-04:00) Atlantic Time (Canada)",
//     utc: [
//       "America/Glace_Bay",
//       "America/Goose_Bay",
//       "America/Halifax",
//       "America/Moncton",
//       "America/Thule",
//       "Atlantic/Bermuda"
//     ]
//   },
//   {
//     value: "Central Brazilian Standard Time",
//     "abbr": "CBST",
//     "offset": -4,
//     "isdst": false,
//     label: "(UTC-04:00) Cuiaba",
//     utc: [
//       "America/Campo_Grande",
//       "America/Cuiaba"
//     ]
//   },
//   {
//     value: "SA Western Standard Time",
//     "abbr": "SWST",
//     "offset": -4,
//     "isdst": false,
//     label: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
//     utc: [
//       "America/Anguilla",
//       "America/Antigua",
//       "America/Aruba",
//       "America/Barbados",
//       "America/Blanc-Sablon",
//       "America/Boa_Vista",
//       "America/Curacao",
//       "America/Dominica",
//       "America/Grand_Turk",
//       "America/Grenada",
//       "America/Guadeloupe",
//       "America/Guyana",
//       "America/Kralendijk",
//       "America/La_Paz",
//       "America/Lower_Princes",
//       "America/Manaus",
//       "America/Marigot",
//       "America/Martinique",
//       "America/Montserrat",
//       "America/Port_of_Spain",
//       "America/Porto_Velho",
//       "America/Puerto_Rico",
//       "America/Santo_Domingo",
//       "America/St_Barthelemy",
//       "America/St_Kitts",
//       "America/St_Lucia",
//       "America/St_Thomas",
//       "America/St_Vincent",
//       "America/Tortola",
//       "Etc/GMT+4"
//     ]
//   },
//   {
//     value: "Pacific SA Standard Time",
//     "abbr": "PSST",
//     "offset": -4,
//     "isdst": false,
//     label: "(UTC-04:00) Santiago",
//     utc: [
//       "America/Santiago",
//       "Antarctica/Palmer"
//     ]
//   },
//   {
//     value: "Newfoundland Standard Time",
//     "abbr": "NDT",
//     "offset": -2.5,
//     "isdst": true,
//     label: "(UTC-03:30) Newfoundland",
//     utc: [
//       "America/St_Johns"
//     ]
//   },
//   {
//     value: "E. South America Standard Time",
//     "abbr": "ESAST",
//     "offset": -3,
//     "isdst": false,
//     label: "(UTC-03:00) Brasilia",
//     utc: [
//       "America/Sao_Paulo"
//     ]
//   },
//   {
//     value: "Argentina Standard Time",
//     "abbr": "AST",
//     "offset": -3,
//     "isdst": false,
//     label: "(UTC-03:00) Buenos Aires",
//     utc: [
//       "America/Argentina/La_Rioja",
//       "America/Argentina/Rio_Gallegos",
//       "America/Argentina/Salta",
//       "America/Argentina/San_Juan",
//       "America/Argentina/San_Luis",
//       "America/Argentina/Tucuman",
//       "America/Argentina/Ushuaia",
//       "America/Buenos_Aires",
//       "America/Catamarca",
//       "America/Cordoba",
//       "America/Jujuy",
//       "America/Mendoza"
//     ]
//   },
//   {
//     value: "SA Eastern Standard Time",
//     "abbr": "SEST",
//     "offset": -3,
//     "isdst": false,
//     label: "(UTC-03:00) Cayenne, Fortaleza",
//     utc: [
//       "America/Araguaina",
//       "America/Belem",
//       "America/Cayenne",
//       "America/Fortaleza",
//       "America/Maceio",
//       "America/Paramaribo",
//       "America/Recife",
//       "America/Santarem",
//       "Antarctica/Rothera",
//       "Atlantic/Stanley",
//       "Etc/GMT+3"
//     ]
//   },
//   {
//     value: "Greenland Standard Time",
//     "abbr": "GDT",
//     "offset": -3,
//     "isdst": true,
//     label: "(UTC-03:00) Greenland",
//     utc: [
//       "America/Godthab"
//     ]
//   },
//   {
//     value: "Montevideo Standard Time",
//     "abbr": "MST",
//     "offset": -3,
//     "isdst": false,
//     label: "(UTC-03:00) Montevideo",
//     utc: [
//       "America/Montevideo"
//     ]
//   },
//   {
//     value: "Bahia Standard Time",
//     "abbr": "BST",
//     "offset": -3,
//     "isdst": false,
//     label: "(UTC-03:00) Salvador",
//     utc: [
//       "America/Bahia"
//     ]
//   },
//   {
//     value: "UTC-02",
//     "abbr": "U",
//     "offset": -2,
//     "isdst": false,
//     label: "(UTC-02:00) Coordinated Universal Time-02",
//     utc: [
//       "America/Noronha",
//       "Atlantic/South_Georgia",
//       "Etc/GMT+2"
//     ]
//   },
//   {
//     value: "Mid-Atlantic Standard Time",
//     "abbr": "MDT",
//     "offset": -1,
//     "isdst": true,
//     label: "(UTC-02:00) Mid-Atlantic - Old",
//     utc: []
//   },
//   {
//     value: "Azores Standard Time",
//     "abbr": "ADT",
//     "offset": 0,
//     "isdst": true,
//     label: "(UTC-01:00) Azores",
//     utc: [
//       "America/Scoresbysund",
//       "Atlantic/Azores"
//     ]
//   },
//   {
//     value: "Cape Verde Standard Time",
//     "abbr": "CVST",
//     "offset": -1,
//     "isdst": false,
//     label: "(UTC-01:00) Cape Verde Is.",
//     utc: [
//       "Atlantic/Cape_Verde",
//       "Etc/GMT+1"
//     ]
//   },
//   {
//     value: "Morocco Standard Time",
//     "abbr": "MDT",
//     "offset": 1,
//     "isdst": true,
//     label: "(UTC) Casablanca",
//     utc: [
//       "Africa/Casablanca",
//       "Africa/El_Aaiun"
//     ]
//   },
//   {
//     value: "utc",
//     "abbr": "utc",
//     "offset": 0,
//     "isdst": false,
//     label: "(UTC) Coordinated Universal Time",
//     utc: [
//       "America/Danmarkshavn",
//       "Etc/GMT"
//     ]
//   },
//   {
//     value: "GMT Standard Time",
//     "abbr": "GMT",
//     "offset": 0,
//     "isdst": false,
//     label: "(UTC) Edinburgh, London",
//     utc: [
//       "Europe/Isle_of_Man",
//       "Europe/Guernsey",
//       "Europe/Jersey",
//       "Europe/London"
//     ]
//   },
//   {
//     value: "British Summer Time",
//     "abbr": "BST",
//     "offset": 1,
//     "isdst": true,
//     label: "(UTC+01:00) Edinburgh, London",
//     utc: [
//       "Europe/Isle_of_Man",
//       "Europe/Guernsey",
//       "Europe/Jersey",
//       "Europe/London"
//     ]
//   },
//   {
//     value: "GMT Standard Time",
//     "abbr": "GDT",
//     "offset": 1,
//     "isdst": true,
//     label: "(UTC) Dublin, Lisbon",
//     utc: [
//       "Atlantic/Canary",
//       "Atlantic/Faeroe",
//       "Atlantic/Madeira",
//       "Europe/Dublin",
//       "Europe/Lisbon"
//     ]
//   },
//   {
//     value: "Greenwich Standard Time",
//     "abbr": "GST",
//     "offset": 0,
//     "isdst": false,
//     label: "(UTC) Monrovia, Reykjavik",
//     utc: [
//       "Africa/Abidjan",
//       "Africa/Accra",
//       "Africa/Bamako",
//       "Africa/Banjul",
//       "Africa/Bissau",
//       "Africa/Conakry",
//       "Africa/Dakar",
//       "Africa/Freetown",
//       "Africa/Lome",
//       "Africa/Monrovia",
//       "Africa/Nouakchott",
//       "Africa/Ouagadougou",
//       "Africa/Sao_Tome",
//       "Atlantic/Reykjavik",
//       "Atlantic/St_Helena"
//     ]
//   },
//   {
//     value: "W. Europe Standard Time",
//     "abbr": "WEDT",
//     "offset": 2,
//     "isdst": true,
//     label: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
//     utc: [
//       "Arctic/Longyearbyen",
//       "Europe/Amsterdam",
//       "Europe/Andorra",
//       "Europe/Berlin",
//       "Europe/Busingen",
//       "Europe/Gibraltar",
//       "Europe/Luxembourg",
//       "Europe/Malta",
//       "Europe/Monaco",
//       "Europe/Oslo",
//       "Europe/Rome",
//       "Europe/San_Marino",
//       "Europe/Stockholm",
//       "Europe/Vaduz",
//       "Europe/Vatican",
//       "Europe/Vienna",
//       "Europe/Zurich"
//     ]
//   },
//   {
//     value: "Central Europe Standard Time",
//     "abbr": "CEDT",
//     "offset": 2,
//     "isdst": true,
//     label: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
//     utc: [
//       "Europe/Belgrade",
//       "Europe/Bratislava",
//       "Europe/Budapest",
//       "Europe/Ljubljana",
//       "Europe/Podgorica",
//       "Europe/Prague",
//       "Europe/Tirane"
//     ]
//   },
//   {
//     value: "Romance Standard Time",
//     "abbr": "RDT",
//     "offset": 2,
//     "isdst": true,
//     label: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
//     utc: [
//       "Africa/Ceuta",
//       "Europe/Brussels",
//       "Europe/Copenhagen",
//       "Europe/Madrid",
//       "Europe/Paris"
//     ]
//   },
//   {
//     value: "Central European Standard Time",
//     "abbr": "CEDT",
//     "offset": 2,
//     "isdst": true,
//     label: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
//     utc: [
//       "Europe/Sarajevo",
//       "Europe/Skopje",
//       "Europe/Warsaw",
//       "Europe/Zagreb"
//     ]
//   },
//   {
//     value: "W. Central Africa Standard Time",
//     "abbr": "WCAST",
//     "offset": 1,
//     "isdst": false,
//     label: "(UTC+01:00) West Central Africa",
//     utc: [
//       "Africa/Algiers",
//       "Africa/Bangui",
//       "Africa/Brazzaville",
//       "Africa/Douala",
//       "Africa/Kinshasa",
//       "Africa/Lagos",
//       "Africa/Libreville",
//       "Africa/Luanda",
//       "Africa/Malabo",
//       "Africa/Ndjamena",
//       "Africa/Niamey",
//       "Africa/Porto-Novo",
//       "Africa/Tunis",
//       "Etc/GMT-1"
//     ]
//   },
//   {
//     value: "Namibia Standard Time",
//     "abbr": "NST",
//     "offset": 1,
//     "isdst": false,
//     label: "(UTC+01:00) Windhoek",
//     utc: [
//       "Africa/Windhoek"
//     ]
//   },
//   {
//     value: "GTB Standard Time",
//     "abbr": "GDT",
//     "offset": 3,
//     "isdst": true,
//     label: "(UTC+02:00) Athens, Bucharest",
//     utc: [
//       "Asia/Nicosia",
//       "Europe/Athens",
//       "Europe/Bucharest",
//       "Europe/Chisinau"
//     ]
//   },
//   {
//     value: "Middle East Standard Time",
//     "abbr": "MEDT",
//     "offset": 3,
//     "isdst": true,
//     label: "(UTC+02:00) Beirut",
//     utc: [
//       "Asia/Beirut"
//     ]
//   },
//   {
//     value: "Egypt Standard Time",
//     "abbr": "EST",
//     "offset": 2,
//     "isdst": false,
//     label: "(UTC+02:00) Cairo",
//     utc: [
//       "Africa/Cairo"
//     ]
//   },
//   {
//     value: "Syria Standard Time",
//     "abbr": "SDT",
//     "offset": 3,
//     "isdst": true,
//     label: "(UTC+02:00) Damascus",
//     utc: [
//       "Asia/Damascus"
//     ]
//   },
//   {
//     value: "E. Europe Standard Time",
//     "abbr": "EEDT",
//     "offset": 3,
//     "isdst": true,
//     label: "(UTC+02:00) E. Europe",
//     utc: [
//       "Asia/Nicosia",
//       "Europe/Athens",
//       "Europe/Bucharest",
//       "Europe/Chisinau",
//       "Europe/Helsinki",
//       "Europe/Kiev",
//       "Europe/Mariehamn",
//       "Europe/Nicosia",
//       "Europe/Riga",
//       "Europe/Sofia",
//       "Europe/Tallinn",
//       "Europe/Uzhgorod",
//       "Europe/Vilnius",
//       "Europe/Zaporozhye"

//     ]
//   },
//   {
//     value: "South Africa Standard Time",
//     "abbr": "SAST",
//     "offset": 2,
//     "isdst": false,
//     label: "(UTC+02:00) Harare, Pretoria",
//     utc: [
//       "Africa/Blantyre",
//       "Africa/Bujumbura",
//       "Africa/Gaborone",
//       "Africa/Harare",
//       "Africa/Johannesburg",
//       "Africa/Kigali",
//       "Africa/Lubumbashi",
//       "Africa/Lusaka",
//       "Africa/Maputo",
//       "Africa/Maseru",
//       "Africa/Mbabane",
//       "Etc/GMT-2"
//     ]
//   },
//   {
//     value: "FLE Standard Time",
//     "abbr": "FDT",
//     "offset": 3,
//     "isdst": true,
//     label: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
//     utc: [
//       "Europe/Helsinki",
//       "Europe/Kiev",
//       "Europe/Mariehamn",
//       "Europe/Riga",
//       "Europe/Sofia",
//       "Europe/Tallinn",
//       "Europe/Uzhgorod",
//       "Europe/Vilnius",
//       "Europe/Zaporozhye"
//     ]
//   },
//   {
//     value: "Turkey Standard Time",
//     "abbr": "TDT",
//     "offset": 3,
//     "isdst": false,
//     label: "(UTC+03:00) Istanbul",
//     utc: [
//       "Europe/Istanbul"
//     ]
//   },
//   {
//     value: "Israel Standard Time",
//     "abbr": "JDT",
//     "offset": 3,
//     "isdst": true,
//     label: "(UTC+02:00) Jerusalem",
//     utc: [
//       "Asia/Jerusalem"
//     ]
//   },
//   {
//     value: "Libya Standard Time",
//     "abbr": "LST",
//     "offset": 2,
//     "isdst": false,
//     label: "(UTC+02:00) Tripoli",
//     utc: [
//       "Africa/Tripoli"
//     ]
//   },
//   {
//     value: "Jordan Standard Time",
//     "abbr": "JST",
//     "offset": 3,
//     "isdst": false,
//     label: "(UTC+03:00) Amman",
//     utc: [
//       "Asia/Amman"
//     ]
//   },
//   {
//     value: "Arabic Standard Time",
//     "abbr": "AST",
//     "offset": 3,
//     "isdst": false,
//     label: "(UTC+03:00) Baghdad",
//     utc: [
//       "Asia/Baghdad"
//     ]
//   },
//   {
//     value: "Kaliningrad Standard Time",
//     "abbr": "KST",
//     "offset": 3,
//     "isdst": false,
//     label: "(UTC+02:00) Kaliningrad",
//     utc: [
//       "Europe/Kaliningrad"
//     ]
//   },
//   {
//     value: "Arab Standard Time",
//     "abbr": "AST",
//     "offset": 3,
//     "isdst": false,
//     label: "(UTC+03:00) Kuwait, Riyadh",
//     utc: [
//       "Asia/Aden",
//       "Asia/Bahrain",
//       "Asia/Kuwait",
//       "Asia/Qatar",
//       "Asia/Riyadh"
//     ]
//   },
//   {
//     value: "E. Africa Standard Time",
//     "abbr": "EAST",
//     "offset": 3,
//     "isdst": false,
//     label: "(UTC+03:00) Nairobi",
//     utc: [
//       "Africa/Addis_Ababa",
//       "Africa/Asmera",
//       "Africa/Dar_es_Salaam",
//       "Africa/Djibouti",
//       "Africa/Juba",
//       "Africa/Kampala",
//       "Africa/Khartoum",
//       "Africa/Mogadishu",
//       "Africa/Nairobi",
//       "Antarctica/Syowa",
//       "Etc/GMT-3",
//       "Indian/Antananarivo",
//       "Indian/Comoro",
//       "Indian/Mayotte"
//     ]
//   },
//   {
//     value: "Moscow Standard Time",
//     "abbr": "MSK",
//     "offset": 3,
//     "isdst": false,
//     label: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
//     utc: [
// 	    "Europe/Kirov",
//       "Europe/Moscow",
//       "Europe/Simferopol",
//       "Europe/Volgograd",
//       "Europe/Minsk"
//     ]
//   },
//   {
//     value: "Samara Time",
//     "abbr": "SAMT",
//     "offset": 4,
//     "isdst": false,
//     label: "(UTC+04:00) Samara, Ulyanovsk, Saratov",
//     utc: [
// 	    "Europe/Astrakhan",
//       "Europe/Samara",
// 	    "Europe/Ulyanovsk"
//     ]
//   },
//   {
//     value: "Iran Standard Time",
//     "abbr": "IDT",
//     "offset": 4.5,
//     "isdst": true,
//     label: "(UTC+03:30) Tehran",
//     utc: [
//       "Asia/Tehran"
//     ]
//   },
//   {
//     value: "Arabian Standard Time",
//     "abbr": "AST",
//     "offset": 4,
//     "isdst": false,
//     label: "(UTC+04:00) Abu Dhabi, Muscat",
//     utc: [
//       "Asia/Dubai",
//       "Asia/Muscat",
//       "Etc/GMT-4"
//     ]
//   },
//   {
//     value: "Azerbaijan Standard Time",
//     "abbr": "ADT",
//     "offset": 5,
//     "isdst": true,
//     label: "(UTC+04:00) Baku",
//     utc: [
//       "Asia/Baku"
//     ]
//   },
//   {
//     value: "Mauritius Standard Time",
//     "abbr": "MST",
//     "offset": 4,
//     "isdst": false,
//     label: "(UTC+04:00) Port Louis",
//     utc: [
//       "Indian/Mahe",
//       "Indian/Mauritius",
//       "Indian/Reunion"
//     ]
//   },
//   {
//     value: "Georgian Standard Time",
//     "abbr": "GET",
//     "offset": 4,
//     "isdst": false,
//     label: "(UTC+04:00) Tbilisi",
//     utc: [
//       "Asia/Tbilisi"
//     ]
//   },
//   {
//     value: "Caucasus Standard Time",
//     "abbr": "CST",
//     "offset": 4,
//     "isdst": false,
//     label: "(UTC+04:00) Yerevan",
//     utc: [
//       "Asia/Yerevan"
//     ]
//   },
//   {
//     value: "Afghanistan Standard Time",
//     "abbr": "AST",
//     "offset": 4.5,
//     "isdst": false,
//     label: "(UTC+04:30) Kabul",
//     utc: [
//       "Asia/Kabul"
//     ]
//   },
//   {
//     value: "West Asia Standard Time",
//     "abbr": "WAST",
//     "offset": 5,
//     "isdst": false,
//     label: "(UTC+05:00) Ashgabat, Tashkent",
//     utc: [
//       "Antarctica/Mawson",
//       "Asia/Aqtau",
//       "Asia/Aqtobe",
//       "Asia/Ashgabat",
//       "Asia/Dushanbe",
//       "Asia/Oral",
//       "Asia/Samarkand",
//       "Asia/Tashkent",
//       "Etc/GMT-5",
//       "Indian/Kerguelen",
//       "Indian/Maldives"
//     ]
//   },
//   {
//     value: "Yekaterinburg Time",
//     "abbr": "YEKT",
//     "offset": 5,
//     "isdst": false,
//     label: "(UTC+05:00) Yekaterinburg",
//     utc: [
//       "Asia/Yekaterinburg"
//     ]
//   },
//   {
//     value: "Pakistan Standard Time",
//     "abbr": "PKT",
//     "offset": 5,
//     "isdst": false,
//     label: "(UTC+05:00) Islamabad, Karachi",
//     utc: [
//       "Asia/Karachi"
//     ]
//   },
//   {
//     value: "India Standard Time",
//     "abbr": "IST",
//     "offset": 5.5,
//     "isdst": false,
//     label: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
//     utc: [
//       "Asia/Kolkata",
//       "Asia/Calcutta"
//     ]
//   },
//   {
//     value: "Sri Lanka Standard Time",
//     "abbr": "SLST",
//     "offset": 5.5,
//     "isdst": false,
//     label: "(UTC+05:30) Sri Jayawardenepura",
//     utc: [
//       "Asia/Colombo"
//     ]
//   },
//   {
//     value: "Nepal Standard Time",
//     "abbr": "NST",
//     "offset": 5.75,
//     "isdst": false,
//     label: "(UTC+05:45) Kathmandu",
//     utc: [
//       "Asia/Kathmandu"
//     ]
//   },
//   {
//     value: "Central Asia Standard Time",
//     "abbr": "CAST",
//     "offset": 6,
//     "isdst": false,
//     label: "(UTC+06:00) Nur-Sultan (Astana)",
//     utc: [
//       "Antarctica/Vostok",
//       "Asia/Almaty",
//       "Asia/Bishkek",
//       "Asia/Qyzylorda",
//       "Asia/Urumqi",
//       "Etc/GMT-6",
//       "Indian/Chagos"
//     ]
//   },
//   {
//     value: "Bangladesh Standard Time",
//     "abbr": "BST",
//     "offset": 6,
//     "isdst": false,
//     label: "(UTC+06:00) Dhaka",
//     utc: [
//       "Asia/Dhaka",
//       "Asia/Thimphu"
//     ]
//   },
//   {
//     value: "Myanmar Standard Time",
//     "abbr": "MST",
//     "offset": 6.5,
//     "isdst": false,
//     label: "(UTC+06:30) Yangon (Rangoon)",
//     utc: [
//       "Asia/Rangoon",
//       "Indian/Cocos"
//     ]
//   },
//   {
//     value: "SE Asia Standard Time",
//     "abbr": "SAST",
//     "offset": 7,
//     "isdst": false,
//     label: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
//     utc: [
//       "Antarctica/Davis",
//       "Asia/Bangkok",
//       "Asia/Hovd",
//       "Asia/Jakarta",
//       "Asia/Phnom_Penh",
//       "Asia/Pontianak",
//       "Asia/Saigon",
//       "Asia/Vientiane",
//       "Etc/GMT-7",
//       "Indian/Christmas"
//     ]
//   },
//   {
//     value: "N. Central Asia Standard Time",
//     "abbr": "NCAST",
//     "offset": 7,
//     "isdst": false,
//     label: "(UTC+07:00) Novosibirsk",
//     utc: [
//       "Asia/Novokuznetsk",
//       "Asia/Novosibirsk",
//       "Asia/Omsk"
//     ]
//   },
//   {
//     value: "China Standard Time",
//     "abbr": "CST",
//     "offset": 8,
//     "isdst": false,
//     label: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
//     utc: [
//       "Asia/Hong_Kong",
//       "Asia/Macau",
//       "Asia/Shanghai"
//     ]
//   },
//   {
//     value: "North Asia Standard Time",
//     "abbr": "NAST",
//     "offset": 8,
//     "isdst": false,
//     label: "(UTC+08:00) Krasnoyarsk",
//     utc: [
//       "Asia/Krasnoyarsk"
//     ]
//   },
//   {
//     value: "Singapore Standard Time",
//     "abbr": "MPST",
//     "offset": 8,
//     "isdst": false,
//     label: "(UTC+08:00) Kuala Lumpur, Singapore",
//     utc: [
//       "Asia/Brunei",
//       "Asia/Kuala_Lumpur",
//       "Asia/Kuching",
//       "Asia/Makassar",
//       "Asia/Manila",
//       "Asia/Singapore",
//       "Etc/GMT-8"
//     ]
//   },
//   {
//     value: "W. Australia Standard Time",
//     "abbr": "WAST",
//     "offset": 8,
//     "isdst": false,
//     label: "(UTC+08:00) Perth",
//     utc: [
//       "Antarctica/Casey",
//       "Australia/Perth"
//     ]
//   },
//   {
//     value: "Taipei Standard Time",
//     "abbr": "TST",
//     "offset": 8,
//     "isdst": false,
//     label: "(UTC+08:00) Taipei",
//     utc: [
//       "Asia/Taipei"
//     ]
//   },
//   {
//     value: "Ulaanbaatar Standard Time",
//     "abbr": "UST",
//     "offset": 8,
//     "isdst": false,
//     label: "(UTC+08:00) Ulaanbaatar",
//     utc: [
//       "Asia/Choibalsan",
//       "Asia/Ulaanbaatar"
//     ]
//   },
//   {
//     value: "North Asia East Standard Time",
//     "abbr": "NAEST",
//     "offset": 8,
//     "isdst": false,
//     label: "(UTC+08:00) Irkutsk",
//     utc: [
//       "Asia/Irkutsk"
//     ]
//   },
//   {
//     value: "Japan Standard Time",
//     "abbr": "JST",
//     "offset": 9,
//     "isdst": false,
//     label: "(UTC+09:00) Osaka, Sapporo, Tokyo",
//     utc: [
//       "Asia/Dili",
//       "Asia/Jayapura",
//       "Asia/Tokyo",
//       "Etc/GMT-9",
//       "Pacific/Palau"
//     ]
//   },
//   {
//     value: "Korea Standard Time",
//     "abbr": "KST",
//     "offset": 9,
//     "isdst": false,
//     label: "(UTC+09:00) Seoul",
//     utc: [
//       "Asia/Pyongyang",
//       "Asia/Seoul"
//     ]
//   },
//   {
//     value: "Cen. Australia Standard Time",
//     "abbr": "CAST",
//     "offset": 9.5,
//     "isdst": false,
//     label: "(UTC+09:30) Adelaide",
//     utc: [
//       "Australia/Adelaide",
//       "Australia/Broken_Hill"
//     ]
//   },
//   {
//     value: "AUS Central Standard Time",
//     "abbr": "ACST",
//     "offset": 9.5,
//     "isdst": false,
//     label: "(UTC+09:30) Darwin",
//     utc: [
//       "Australia/Darwin"
//     ]
//   },
//   {
//     value: "E. Australia Standard Time",
//     "abbr": "EAST",
//     "offset": 10,
//     "isdst": false,
//     label: "(UTC+10:00) Brisbane",
//     utc: [
//       "Australia/Brisbane",
//       "Australia/Lindeman"
//     ]
//   },
//   {
//     value: "AUS Eastern Standard Time",
//     "abbr": "AEST",
//     "offset": 10,
//     "isdst": false,
//     label: "(UTC+10:00) Canberra, Melbourne, Sydney",
//     utc: [
//       "Australia/Melbourne",
//       "Australia/Sydney"
//     ]
//   },
//   {
//     value: "West Pacific Standard Time",
//     "abbr": "WPST",
//     "offset": 10,
//     "isdst": false,
//     label: "(UTC+10:00) Guam, Port Moresby",
//     utc: [
//       "Antarctica/DumontDUrville",
//       "Etc/GMT-10",
//       "Pacific/Guam",
//       "Pacific/Port_Moresby",
//       "Pacific/Saipan",
//       "Pacific/Truk"
//     ]
//   },
//   {
//     value: "Tasmania Standard Time",
//     "abbr": "TST",
//     "offset": 10,
//     "isdst": false,
//     label: "(UTC+10:00) Hobart",
//     utc: [
//       "Australia/Currie",
//       "Australia/Hobart"
//     ]
//   },
//   {
//     value: "Yakutsk Standard Time",
//     "abbr": "YST",
//     "offset": 9,
//     "isdst": false,
//     label: "(UTC+09:00) Yakutsk",
//     utc: [
//       "Asia/Chita",
//       "Asia/Khandyga",
//       "Asia/Yakutsk"
//     ]
//   },
//   {
//     value: "Central Pacific Standard Time",
//     "abbr": "CPST",
//     "offset": 11,
//     "isdst": false,
//     label: "(UTC+11:00) Solomon Is., New Caledonia",
//     utc: [
//       "Antarctica/Macquarie",
//       "Etc/GMT-11",
//       "Pacific/Efate",
//       "Pacific/Guadalcanal",
//       "Pacific/Kosrae",
//       "Pacific/Noumea",
//       "Pacific/Ponape"
//     ]
//   },
//   {
//     value: "Vladivostok Standard Time",
//     "abbr": "VST",
//     "offset": 11,
//     "isdst": false,
//     label: "(UTC+11:00) Vladivostok",
//     utc: [
//       "Asia/Sakhalin",
//       "Asia/Ust-Nera",
//       "Asia/Vladivostok"
//     ]
//   },
//   {
//     value: "New Zealand Standard Time",
//     "abbr": "NZST",
//     "offset": 12,
//     "isdst": false,
//     label: "(UTC+12:00) Auckland, Wellington",
//     utc: [
//       "Antarctica/McMurdo",
//       "Pacific/Auckland"
//     ]
//   },
//   {
//     value: "UTC+12",
//     "abbr": "U",
//     "offset": 12,
//     "isdst": false,
//     label: "(UTC+12:00) Coordinated Universal Time+12",
//     utc: [
//       "Etc/GMT-12",
//       "Pacific/Funafuti",
//       "Pacific/Kwajalein",
//       "Pacific/Majuro",
//       "Pacific/Nauru",
//       "Pacific/Tarawa",
//       "Pacific/Wake",
//       "Pacific/Wallis"
//     ]
//   },
//   {
//     value: "Fiji Standard Time",
//     "abbr": "FST",
//     "offset": 12,
//     "isdst": false,
//     label: "(UTC+12:00) Fiji",
//     utc: [
//       "Pacific/Fiji"
//     ]
//   },
//   {
//     value: "Magadan Standard Time",
//     "abbr": "MST",
//     "offset": 12,
//     "isdst": false,
//     label: "(UTC+12:00) Magadan",
//     utc: [
//       "Asia/Anadyr",
//       "Asia/Kamchatka",
//       "Asia/Magadan",
//       "Asia/Srednekolymsk"
//     ]
//   },
//   {
//     value: "Kamchatka Standard Time",
//     "abbr": "KDT",
//     "offset": 13,
//     "isdst": true,
//     label: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
//     utc: [
//       "Asia/Kamchatka"
//     ]
//   },
//   {
//     value: "Tonga Standard Time",
//     "abbr": "TST",
//     "offset": 13,
//     "isdst": false,
//     label: "(UTC+13:00) Nuku'alofa",
//     utc: [
//       "Etc/GMT-13",
//       "Pacific/Enderbury",
//       "Pacific/Fakaofo",
//       "Pacific/Tongatapu"
//     ]
//   },
//   {
//     value: "Samoa Standard Time",
//     "abbr": "SST",
//     "offset": 13,
//     "isdst": false,
//     label: "(UTC+13:00) Samoa",
//     utc: [
//       "Pacific/Apia"
//     ]
//   }
// ]


export const timeZones = [{ "label": "(UTC-11:00) Pacific, Midway", "value": "Pacific/Midway" }, { "label": "(UTC-11:00) Pacific, Niue", "value": "Pacific/Niue" }, { "label": "(UTC-11:00) Pacific, Pago-Pago", "value": "Pacific/Pago_Pago" }, { "label": "(UTC-11:00) Pacific, Samoa", "value": "Pacific/Samoa" }, { "label": "(UTC-11:00) US, Samoa", "value": "US/Samoa" }, { "label": "(UTC-09:00) America, Adak", "value": "America/Adak" }, { "label": "(UTC-09:00) America, Atka", "value": "America/Atka" }, { "label": "(UTC-10:00) Pacific, Honolulu", "value": "Pacific/Honolulu" }, { "label": "(UTC-10:00) Pacific, Johnston", "value": "Pacific/Johnston" }, { "label": "(UTC-10:00) Pacific, Rarotonga", "value": "Pacific/Rarotonga" }, { "label": "(UTC-10:00) Pacific, Tahiti", "value": "Pacific/Tahiti" }, { "label": "(UTC-10:00) SystemV, HST10", "value": "SystemV/HST10" }, { "label": "(UTC-09:00) US, Aleutian", "value": "US/Aleutian" }, { "label": "(UTC-10:00) US, Hawaii", "value": "US/Hawaii" }, { "label": "(UTC-10:00) HST", "value": "HST" }, { "label": "(UTC-09:30) Pacific, Marquesas", "value": "Pacific/Marquesas" }, { "label": "(UTC-08:00) America, Anchorage", "value": "America/Anchorage" }, { "label": "(UTC-08:00) America, Juneau", "value": "America/Juneau" }, { "label": "(UTC-08:00) America, Metlakatla", "value": "America/Metlakatla" }, { "label": "(UTC-08:00) America, Nome", "value": "America/Nome" }, { "label": "(UTC-08:00) America, Sitka", "value": "America/Sitka" }, { "label": "(UTC-08:00) America, Yakutat", "value": "America/Yakutat" }, { "label": "(UTC-09:00) Pacific, Gambier", "value": "Pacific/Gambier" }, { "label": "(UTC-09:00) SystemV, YST9", "value": "SystemV/YST9" }, { "label": "(UTC-09:00) SystemV, YST9YDT", "value": "SystemV/YST9YDT" }, { "label": "(UTC-08:00) US, Alaska", "value": "US/Alaska" }, { "label": "(UTC-08:00) AST", "value": "AST" }, { "label": "(UTC-07:00) America, Dawson", "value": "America/Dawson" }, { "label": "(UTC-07:00) America, Ensenada", "value": "America/Ensenada" }, { "label": "(UTC-07:00) America, Los-Angeles", "value": "America/Los_Angeles" }, { "label": "(UTC-07:00) America, Santa-Isabel", "value": "America/Santa_Isabel" }, { "label": "(UTC-07:00) America, Tijuana", "value": "America/Tijuana" }, { "label": "(UTC-07:00) America, Vancouver", "value": "America/Vancouver" }, { "label": "(UTC-07:00) America, Whitehorse", "value": "America/Whitehorse" }, { "label": "(UTC-07:00) Canada, Pacific", "value": "Canada/Pacific" }, { "label": "(UTC-07:00) Canada, Yukon", "value": "Canada/Yukon" }, { "label": "(UTC-07:00) Mexico, BajaNorte", "value": "Mexico/BajaNorte" }, { "label": "(UTC-07:00) PST8PDT", "value": "PST8PDT" }, { "label": "(UTC-08:00) Pacific, Pitcairn", "value": "Pacific/Pitcairn" }, { "label": "(UTC-08:00) SystemV, PST8", "value": "SystemV/PST8" }, { "label": "(UTC-08:00) SystemV, PST8PDT", "value": "SystemV/PST8PDT" }, { "label": "(UTC-07:00) US, Pacific", "value": "US/Pacific" }, { "label": "(UTC-07:00) US, Pacific-New", "value": "US/Pacific-New" }, { "label": "(UTC-07:00) PST", "value": "PST" }, { "label": "(UTC-06:00) America, Boise", "value": "America/Boise" }, { "label": "(UTC-06:00) America, Cambridge-Bay", "value": "America/Cambridge_Bay" }, { "label": "(UTC-07:00) America, Chihuahua", "value": "America/Chihuahua" }, { "label": "(UTC-07:00) America, Creston", "value": "America/Creston" }, { "label": "(UTC-07:00) America, Dawson-Creek", "value": "America/Dawson_Creek" }, { "label": "(UTC-06:00) America, Denver", "value": "America/Denver" }, { "label": "(UTC-06:00) America, Edmonton", "value": "America/Edmonton" }, { "label": "(UTC-07:00) America, Fort-Nelson", "value": "America/Fort_Nelson" }, { "label": "(UTC-07:00) America, Hermosillo", "value": "America/Hermosillo" }, { "label": "(UTC-06:00) America, Inuvik", "value": "America/Inuvik" }, { "label": "(UTC-07:00) America, Mazatlan", "value": "America/Mazatlan" }, { "label": "(UTC-06:00) America, Ojinaga", "value": "America/Ojinaga" }, { "label": "(UTC-07:00) America, Phoenix", "value": "America/Phoenix" }, { "label": "(UTC-06:00) America, Shiprock", "value": "America/Shiprock" }, { "label": "(UTC-06:00) America, Yellowknife", "value": "America/Yellowknife" }, { "label": "(UTC-06:00) Canada, Mountain", "value": "Canada/Mountain" }, { "label": "(UTC-06:00) MST7MDT", "value": "MST7MDT" }, { "label": "(UTC-07:00) Mexico, BajaSur", "value": "Mexico/BajaSur" }, { "label": "(UTC-06:00) Navajo", "value": "Navajo" }, { "label": "(UTC-07:00) SystemV, MST7", "value": "SystemV/MST7" }, { "label": "(UTC-07:00) SystemV, MST7MDT", "value": "SystemV/MST7MDT" }, { "label": "(UTC-07:00) US, Arizona", "value": "US/Arizona" }, { "label": "(UTC-06:00) US, Mountain", "value": "US/Mountain" }, { "label": "(UTC-07:00) MST", "value": "MST" }, { "label": "(UTC-07:00) PNT", "value": "PNT" }, { "label": "(UTC-06:00) America, Bahia-Banderas", "value": "America/Bahia_Banderas" }, { "label": "(UTC-06:00) America, Belize", "value": "America/Belize" }, { "label": "(UTC-05:00) America, Chicago", "value": "America/Chicago" }, { "label": "(UTC-06:00) America, Costa-Rica", "value": "America/Costa_Rica" }, { "label": "(UTC-06:00) America, El-Salvador", "value": "America/El_Salvador" }, { "label": "(UTC-06:00) America, Guatemala", "value": "America/Guatemala" }, { "label": "(UTC-05:00) America, Indiana, Knox", "value": "America/Indiana/Knox" }, { "label": "(UTC-05:00) America, Indiana, Tell-City", "value": "America/Indiana/Tell_City" }, { "label": "(UTC-05:00) America, Knox-IN", "value": "America/Knox_IN" }, { "label": "(UTC-06:00) America, Managua", "value": "America/Managua" }, { "label": "(UTC-05:00) America, Matamoros", "value": "America/Matamoros" }, { "label": "(UTC-05:00) America, Menominee", "value": "America/Menominee" }, { "label": "(UTC-06:00) America, Merida", "value": "America/Merida" }, { "label": "(UTC-06:00) America, Mexico-City", "value": "America/Mexico_City" }, { "label": "(UTC-06:00) America, Monterrey", "value": "America/Monterrey" }, { "label": "(UTC-05:00) America, North-Dakota, Beulah", "value": "America/North_Dakota/Beulah" }, { "label": "(UTC-05:00) America, North-Dakota, Center", "value": "America/North_Dakota/Center" }, { "label": "(UTC-05:00) America, North-Dakota, New-Salem", "value": "America/North_Dakota/New_Salem" }, { "label": "(UTC-05:00) America, Rainy-River", "value": "America/Rainy_River" }, { "label": "(UTC-05:00) America, Rankin-Inlet", "value": "America/Rankin_Inlet" }, { "label": "(UTC-06:00) America, Regina", "value": "America/Regina" }, { "label": "(UTC-05:00) America, Resolute", "value": "America/Resolute" }, { "label": "(UTC-06:00) America, Swift-Current", "value": "America/Swift_Current" }, { "label": "(UTC-06:00) America, Tegucigalpa", "value": "America/Tegucigalpa" }, { "label": "(UTC-05:00) America, Winnipeg", "value": "America/Winnipeg" }, { "label": "(UTC-05:00) CST6CDT", "value": "CST6CDT" }, { "label": "(UTC-05:00) Canada, Central", "value": "Canada/Central" }, { "label": "(UTC-06:00) Canada, Saskatchewan", "value": "Canada/Saskatchewan" }, { "label": "(UTC-05:00) Chile, EasterIsland", "value": "Chile/EasterIsland" }, { "label": "(UTC-06:00) Mexico, General", "value": "Mexico/General" }, { "label": "(UTC-05:00) Pacific, Easter", "value": "Pacific/Easter" }, { "label": "(UTC-06:00) Pacific, Galapagos", "value": "Pacific/Galapagos" }, { "label": "(UTC-06:00) SystemV, CST6", "value": "SystemV/CST6" }, { "label": "(UTC-06:00) SystemV, CST6CDT", "value": "SystemV/CST6CDT" }, { "label": "(UTC-05:00) US, Central", "value": "US/Central" }, { "label": "(UTC-05:00) US, Indiana-Starke", "value": "US/Indiana-Starke" }, { "label": "(UTC-05:00) CST", "value": "CST" }, { "label": "(UTC-05:00) America, Atikokan", "value": "America/Atikokan" }, { "label": "(UTC-05:00) America, Bogota", "value": "America/Bogota" }, { "label": "(UTC-05:00) America, Cancun", "value": "America/Cancun" }, { "label": "(UTC-05:00) America, Cayman", "value": "America/Cayman" }, { "label": "(UTC-05:00) America, Coral-Harbour", "value": "America/Coral_Harbour" }, { "label": "(UTC-04:00) America, Detroit", "value": "America/Detroit" }, { "label": "(UTC-05:00) America, Eirunepe", "value": "America/Eirunepe" }, { "label": "(UTC-04:00) America, Fort-Wayne", "value": "America/Fort_Wayne" }, { "label": "(UTC-04:00) America, Grand-Turk", "value": "America/Grand_Turk" }, { "label": "(UTC-05:00) America, Guayaquil", "value": "America/Guayaquil" }, { "label": "(UTC-04:00) America, Havana", "value": "America/Havana" }, { "label": "(UTC-04:00) America, Indiana, Indianapolis", "value": "America/Indiana/Indianapolis" }, { "label": "(UTC-04:00) America, Indiana, Marengo", "value": "America/Indiana/Marengo" }, { "label": "(UTC-04:00) America, Indiana, Petersburg", "value": "America/Indiana/Petersburg" }, { "label": "(UTC-04:00) America, Indiana, Vevay", "value": "America/Indiana/Vevay" }, { "label": "(UTC-04:00) America, Indiana, Vincennes", "value": "America/Indiana/Vincennes" }, { "label": "(UTC-04:00) America, Indiana, Winamac", "value": "America/Indiana/Winamac" }, { "label": "(UTC-04:00) America, Indianapolis", "value": "America/Indianapolis" }, { "label": "(UTC-04:00) America, Iqaluit", "value": "America/Iqaluit" }, { "label": "(UTC-05:00) America, Jamaica", "value": "America/Jamaica" }, { "label": "(UTC-04:00) America, Kentucky, Louisville", "value": "America/Kentucky/Louisville" }, { "label": "(UTC-04:00) America, Kentucky, Monticello", "value": "America/Kentucky/Monticello" }, { "label": "(UTC-05:00) America, Lima", "value": "America/Lima" }, { "label": "(UTC-04:00) America, Louisville", "value": "America/Louisville" }, { "label": "(UTC-04:00) America, Montreal", "value": "America/Montreal" }, { "label": "(UTC-04:00) America, Nassau", "value": "America/Nassau" }, { "label": "(UTC-04:00) America, New-York", "value": "America/New_York" }, { "label": "(UTC-04:00) America, Nipigon", "value": "America/Nipigon" }, { "label": "(UTC-05:00) America, Panama", "value": "America/Panama" }, { "label": "(UTC-04:00) America, Pangnirtung", "value": "America/Pangnirtung" }, { "label": "(UTC-04:00) America, Port-au-Prince", "value": "America/Port-au-Prince" }, { "label": "(UTC-05:00) America, Porto-Acre", "value": "America/Porto_Acre" }, { "label": "(UTC-05:00) America, Rio-Branco", "value": "America/Rio_Branco" }, { "label": "(UTC-04:00) America, Thunder-Bay", "value": "America/Thunder_Bay" }, { "label": "(UTC-04:00) America, Toronto", "value": "America/Toronto" }, { "label": "(UTC-05:00) Brazil, Acre", "value": "Brazil/Acre" }, { "label": "(UTC-04:00) Canada, Eastern", "value": "Canada/Eastern" }, { "label": "(UTC-04:00) Cuba", "value": "Cuba" }, { "label": "(UTC-04:00) EST5EDT", "value": "EST5EDT" }, { "label": "(UTC-05:00) Jamaica", "value": "Jamaica" }, { "label": "(UTC-05:00) SystemV, EST5", "value": "SystemV/EST5" }, { "label": "(UTC-05:00) SystemV, EST5EDT", "value": "SystemV/EST5EDT" }, { "label": "(UTC-04:00) US, East-Indiana", "value": "US/East-Indiana" }, { "label": "(UTC-04:00) US, Eastern", "value": "US/Eastern" }, { "label": "(UTC-04:00) US, Michigan", "value": "US/Michigan" }, { "label": "(UTC-05:00) EST", "value": "EST" }, { "label": "(UTC-04:00) IET", "value": "IET" }, { "label": "(UTC-04:00) America, Anguilla", "value": "America/Anguilla" }, { "label": "(UTC-04:00) America, Antigua", "value": "America/Antigua" }, { "label": "(UTC-04:00) America, Aruba", "value": "America/Aruba" }, { "label": "(UTC-03:00) America, Asuncion", "value": "America/Asuncion" }, { "label": "(UTC-04:00) America, Barbados", "value": "America/Barbados" }, { "label": "(UTC-04:00) America, Blanc-Sablon", "value": "America/Blanc-Sablon" }, { "label": "(UTC-04:00) America, Boa-Vista", "value": "America/Boa_Vista" }, { "label": "(UTC-04:00) America, Campo-Grande", "value": "America/Campo_Grande" }, { "label": "(UTC-04:00) America, Caracas", "value": "America/Caracas" }, { "label": "(UTC-04:00) America, Cuiaba", "value": "America/Cuiaba" }, { "label": "(UTC-04:00) America, Curacao", "value": "America/Curacao" }, { "label": "(UTC-04:00) America, Dominica", "value": "America/Dominica" }, { "label": "(UTC-03:00) America, Glace-Bay", "value": "America/Glace_Bay" }, { "label": "(UTC-03:00) America, Goose-Bay", "value": "America/Goose_Bay" }, { "label": "(UTC-04:00) America, Grenada", "value": "America/Grenada" }, { "label": "(UTC-04:00) America, Guadeloupe", "value": "America/Guadeloupe" }, { "label": "(UTC-04:00) America, Guyana", "value": "America/Guyana" }, { "label": "(UTC-03:00) America, Halifax", "value": "America/Halifax" }, { "label": "(UTC-04:00) America, Kralendijk", "value": "America/Kralendijk" }, { "label": "(UTC-04:00) America, La-Paz", "value": "America/La_Paz" }, { "label": "(UTC-04:00) America, Lower-Princes", "value": "America/Lower_Princes" }, { "label": "(UTC-04:00) America, Manaus", "value": "America/Manaus" }, { "label": "(UTC-04:00) America, Marigot", "value": "America/Marigot" }, { "label": "(UTC-04:00) America, Martinique", "value": "America/Martinique" }, { "label": "(UTC-03:00) America, Moncton", "value": "America/Moncton" }, { "label": "(UTC-04:00) America, Montserrat", "value": "America/Montserrat" }, { "label": "(UTC-04:00) America, Port-of-Spain", "value": "America/Port_of_Spain" }, { "label": "(UTC-04:00) America, Porto-Velho", "value": "America/Porto_Velho" }, { "label": "(UTC-04:00) America, Puerto-Rico", "value": "America/Puerto_Rico" }, { "label": "(UTC-03:00) America, Santiago", "value": "America/Santiago" }, { "label": "(UTC-04:00) America, Santo-Domingo", "value": "America/Santo_Domingo" }, { "label": "(UTC-04:00) America, St-Barthelemy", "value": "America/St_Barthelemy" }, { "label": "(UTC-04:00) America, St-Kitts", "value": "America/St_Kitts" }, { "label": "(UTC-04:00) America, St-Lucia", "value": "America/St_Lucia" }, { "label": "(UTC-04:00) America, St-Thomas", "value": "America/St_Thomas" }, { "label": "(UTC-04:00) America, St-Vincent", "value": "America/St_Vincent" }, { "label": "(UTC-03:00) America, Thule", "value": "America/Thule" }, { "label": "(UTC-04:00) America, Tortola", "value": "America/Tortola" }, { "label": "(UTC-04:00) America, Virgin", "value": "America/Virgin" }, { "label": "(UTC-03:00) Atlantic, Bermuda", "value": "Atlantic/Bermuda" }, { "label": "(UTC-04:00) Brazil, West", "value": "Brazil/West" }, { "label": "(UTC-03:00) Canada, Atlantic", "value": "Canada/Atlantic" }, { "label": "(UTC-03:00) Chile, Continental", "value": "Chile/Continental" }, { "label": "(UTC-04:00) SystemV, AST4", "value": "SystemV/AST4" }, { "label": "(UTC-04:00) SystemV, AST4ADT", "value": "SystemV/AST4ADT" }, { "label": "(UTC-04:00) PRT", "value": "PRT" }, { "label": "(UTC-02:30) America, St-Johns", "value": "America/St_Johns" }, { "label": "(UTC-02:30) Canada, Newfoundland", "value": "Canada/Newfoundland" }, { "label": "(UTC-02:30) CNT", "value": "CNT" }, { "label": "(UTC-03:00) America, Araguaina", "value": "America/Araguaina" }, { "label": "(UTC-03:00) America, Argentina, Buenos-Aires", "value": "America/Argentina/Buenos_Aires" }, { "label": "(UTC-03:00) America, Argentina, Catamarca", "value": "America/Argentina/Catamarca" }, { "label": "(UTC-03:00) America, Argentina, ComodRivadavia", "value": "America/Argentina/ComodRivadavia" }, { "label": "(UTC-03:00) America, Argentina, Cordoba", "value": "America/Argentina/Cordoba" }, { "label": "(UTC-03:00) America, Argentina, Jujuy", "value": "America/Argentina/Jujuy" }, { "label": "(UTC-03:00) America, Argentina, La-Rioja", "value": "America/Argentina/La_Rioja" }, { "label": "(UTC-03:00) America, Argentina, Mendoza", "value": "America/Argentina/Mendoza" }, { "label": "(UTC-03:00) America, Argentina, Rio-Gallegos", "value": "America/Argentina/Rio_Gallegos" }, { "label": "(UTC-03:00) America, Argentina, Salta", "value": "America/Argentina/Salta" }, { "label": "(UTC-03:00) America, Argentina, San-Juan", "value": "America/Argentina/San_Juan" }, { "label": "(UTC-03:00) America, Argentina, San-Luis", "value": "America/Argentina/San_Luis" }, { "label": "(UTC-03:00) America, Argentina, Tucuman", "value": "America/Argentina/Tucuman" }, { "label": "(UTC-03:00) America, Argentina, Ushuaia", "value": "America/Argentina/Ushuaia" }, { "label": "(UTC-03:00) America, Bahia", "value": "America/Bahia" }, { "label": "(UTC-03:00) America, Belem", "value": "America/Belem" }, { "label": "(UTC-03:00) America, Buenos-Aires", "value": "America/Buenos_Aires" }, { "label": "(UTC-03:00) America, Catamarca", "value": "America/Catamarca" }, { "label": "(UTC-03:00) America, Cayenne", "value": "America/Cayenne" }, { "label": "(UTC-03:00) America, Cordoba", "value": "America/Cordoba" }, { "label": "(UTC-03:00) America, Fortaleza", "value": "America/Fortaleza" }, { "label": "(UTC-03:00) America, Godthab", "value": "America/Godthab" }, { "label": "(UTC-03:00) America, Jujuy", "value": "America/Jujuy" }, { "label": "(UTC-03:00) America, Maceio", "value": "America/Maceio" }, { "label": "(UTC-03:00) America, Mendoza", "value": "America/Mendoza" }, { "label": "(UTC-02:00) America, Miquelon", "value": "America/Miquelon" }, { "label": "(UTC-03:00) America, Montevideo", "value": "America/Montevideo" }, { "label": "(UTC-03:00) America, Paramaribo", "value": "America/Paramaribo" }, { "label": "(UTC-03:00) America, Punta-Arenas", "value": "America/Punta_Arenas" }, { "label": "(UTC-03:00) America, Recife", "value": "America/Recife" }, { "label": "(UTC-03:00) America, Rosario", "value": "America/Rosario" }, { "label": "(UTC-03:00) America, Santarem", "value": "America/Santarem" }, { "label": "(UTC-03:00) America, Sao-Paulo", "value": "America/Sao_Paulo" }, { "label": "(UTC-03:00) Antarctica, Palmer", "value": "Antarctica/Palmer" }, { "label": "(UTC-03:00) Antarctica, Rothera", "value": "Antarctica/Rothera" }, { "label": "(UTC-03:00) Atlantic, Stanley", "value": "Atlantic/Stanley" }, { "label": "(UTC-03:00) Brazil, East", "value": "Brazil/East" }, { "label": "(UTC-03:00) AGT", "value": "AGT" }, { "label": "(UTC-03:00) BET", "value": "BET" }, { "label": "(UTC-02:00) America, Noronha", "value": "America/Noronha" }, { "label": "(UTC-02:00) Atlantic, South-Georgia", "value": "Atlantic/South_Georgia" }, { "label": "(UTC-02:00) Brazil, DeNoronha", "value": "Brazil/DeNoronha" }, { "label": "(UTC-01:00) America, Scoresbysund", "value": "America/Scoresbysund" }, { "label": "(UTC-01:00) Atlantic, Azores", "value": "Atlantic/Azores" }, { "label": "(UTC-01:00) Atlantic, Cape-Verde", "value": "Atlantic/Cape_Verde" }, { "label": "(UTC+00:00) Africa, Abidjan", "value": "Africa/Abidjan" }, { "label": "(UTC+00:00) Africa, Accra", "value": "Africa/Accra" }, { "label": "(UTC+00:00) Africa, Bamako", "value": "Africa/Bamako" }, { "label": "(UTC+00:00) Africa, Banjul", "value": "Africa/Banjul" }, { "label": "(UTC+00:00) Africa, Bissau", "value": "Africa/Bissau" }, { "label": "(UTC+00:00) Africa, Conakry", "value": "Africa/Conakry" }, { "label": "(UTC+00:00) Africa, Dakar", "value": "Africa/Dakar" }, { "label": "(UTC+00:00) Africa, Freetown", "value": "Africa/Freetown" }, { "label": "(UTC+00:00) Africa, Lome", "value": "Africa/Lome" }, { "label": "(UTC+00:00) Africa, Monrovia", "value": "Africa/Monrovia" }, { "label": "(UTC+00:00) Africa, Nouakchott", "value": "Africa/Nouakchott" }, { "label": "(UTC+00:00) Africa, Ouagadougou", "value": "Africa/Ouagadougou" }, { "label": "(UTC+00:00) Africa, Timbuktu", "value": "Africa/Timbuktu" }, { "label": "(UTC+00:00) America, Danmarkshavn", "value": "America/Danmarkshavn" }, { "label": "(UTC+00:00) Antarctica, Troll", "value": "Antarctica/Troll" }, { "label": "(UTC+00:00) Atlantic, Canary", "value": "Atlantic/Canary" }, { "label": "(UTC+00:00) Atlantic, Faeroe", "value": "Atlantic/Faeroe" }, { "label": "(UTC+00:00) Atlantic, Faroe", "value": "Atlantic/Faroe" }, { "label": "(UTC+00:00) Atlantic, Madeira", "value": "Atlantic/Madeira" }, { "label": "(UTC+00:00) Atlantic, Reykjavik", "value": "Atlantic/Reykjavik" }, { "label": "(UTC+00:00) Atlantic, St-Helena", "value": "Atlantic/St_Helena" }, { "label": "(UTC+00:00) Eire", "value": "Eire" }, { "label": "(UTC+00:00) Europe, Belfast", "value": "Europe/Belfast" }, { "label": "(UTC+00:00) Europe, Dublin", "value": "Europe/Dublin" }, { "label": "(UTC+00:00) Europe, Guernsey", "value": "Europe/Guernsey" }, { "label": "(UTC+00:00) Europe, Isle-of-Man", "value": "Europe/Isle_of_Man" }, { "label": "(UTC+00:00) Europe, Jersey", "value": "Europe/Jersey" }, { "label": "(UTC+00:00) Europe, Lisbon", "value": "Europe/Lisbon" }, { "label": "(UTC+00:00) Europe, London", "value": "Europe/London" }, { "label": "(UTC+00:00) GB", "value": "GB" }, { "label": "(UTC+00:00) GB-Eire", "value": "GB-Eire" }, { "label": "(UTC+00:00) GMT", "value": "GMT" }, { "label": "(UTC+00:00) GMT0", "value": "GMT0" }, { "label": "(UTC+00:00) Greenwich", "value": "Greenwich" }, { "label": "(UTC+00:00) Iceland", "value": "Iceland" }, { "label": "(UTC+00:00) Portugal", "value": "Portugal" }, { "label": "(UTC+00:00) UCT", "value": "UCT" }, { "label": "(UTC+00:00) UTC", "value": "UTC" }, { "label": "(UTC+00:00) Universal", "value": "Universal" }, { "label": "(UTC+00:00) WET", "value": "WET" }, { "label": "(UTC+00:00) Zulu", "value": "Zulu" }, { "label": "(UTC+01:00) Africa, Algiers", "value": "Africa/Algiers" }, { "label": "(UTC+01:00) Africa, Bangui", "value": "Africa/Bangui" }, { "label": "(UTC+01:00) Africa, Brazzaville", "value": "Africa/Brazzaville" }, { "label": "(UTC+01:00) Africa, Casablanca", "value": "Africa/Casablanca" }, { "label": "(UTC+01:00) Africa, Ceuta", "value": "Africa/Ceuta" }, { "label": "(UTC+01:00) Africa, Douala", "value": "Africa/Douala" }, { "label": "(UTC+01:00) Africa, El-Aaiun", "value": "Africa/El_Aaiun" }, { "label": "(UTC+01:00) Africa, Kinshasa", "value": "Africa/Kinshasa" }, { "label": "(UTC+01:00) Africa, Lagos", "value": "Africa/Lagos" }, { "label": "(UTC+01:00) Africa, Libreville", "value": "Africa/Libreville" }, { "label": "(UTC+01:00) Africa, Luanda", "value": "Africa/Luanda" }, { "label": "(UTC+01:00) Africa, Malabo", "value": "Africa/Malabo" }, { "label": "(UTC+01:00) Africa, Ndjamena", "value": "Africa/Ndjamena" }, { "label": "(UTC+01:00) Africa, Niamey", "value": "Africa/Niamey" }, { "label": "(UTC+01:00) Africa, Porto-Novo", "value": "Africa/Porto-Novo" }, { "label": "(UTC+01:00) Africa, Sao-Tome", "value": "Africa/Sao_Tome" }, { "label": "(UTC+01:00) Africa, Tunis", "value": "Africa/Tunis" }, { "label": "(UTC+01:00) Arctic, Longyearbyen", "value": "Arctic/Longyearbyen" }, { "label": "(UTC+01:00) Atlantic, Jan-Mayen", "value": "Atlantic/Jan_Mayen" }, { "label": "(UTC+01:00) CET", "value": "CET" }, { "label": "(UTC+01:00) Europe, Amsterdam", "value": "Europe/Amsterdam" }, { "label": "(UTC+01:00) Europe, Andorra", "value": "Europe/Andorra" }, { "label": "(UTC+01:00) Europe, Belgrade", "value": "Europe/Belgrade" }, { "label": "(UTC+01:00) Europe, Berlin", "value": "Europe/Berlin" }, { "label": "(UTC+01:00) Europe, Bratislava", "value": "Europe/Bratislava" }, { "label": "(UTC+01:00) Europe, Brussels", "value": "Europe/Brussels" }, { "label": "(UTC+01:00) Europe, Budapest", "value": "Europe/Budapest" }, { "label": "(UTC+01:00) Europe, Busingen", "value": "Europe/Busingen" }, { "label": "(UTC+01:00) Europe, Copenhagen", "value": "Europe/Copenhagen" }, { "label": "(UTC+01:00) Europe, Gibraltar", "value": "Europe/Gibraltar" }, { "label": "(UTC+01:00) Europe, Ljubljana", "value": "Europe/Ljubljana" }, { "label": "(UTC+01:00) Europe, Luxembourg", "value": "Europe/Luxembourg" }, { "label": "(UTC+01:00) Europe, Madrid", "value": "Europe/Madrid" }, { "label": "(UTC+01:00) Europe, Malta", "value": "Europe/Malta" }, { "label": "(UTC+01:00) Europe, Monaco", "value": "Europe/Monaco" }, { "label": "(UTC+01:00) Europe, Oslo", "value": "Europe/Oslo" }, { "label": "(UTC+01:00) Europe, Paris", "value": "Europe/Paris" }, { "label": "(UTC+01:00) Europe, Podgorica", "value": "Europe/Podgorica" }, { "label": "(UTC+01:00) Europe, Prague", "value": "Europe/Prague" }, { "label": "(UTC+01:00) Europe, Rome", "value": "Europe/Rome" }, { "label": "(UTC+01:00) Europe, San-Marino", "value": "Europe/San_Marino" }, { "label": "(UTC+01:00) Europe, Sarajevo", "value": "Europe/Sarajevo" }, { "label": "(UTC+01:00) Europe, Skopje", "value": "Europe/Skopje" }, { "label": "(UTC+01:00) Europe, Stockholm", "value": "Europe/Stockholm" }, { "label": "(UTC+01:00) Europe, Tirane", "value": "Europe/Tirane" }, { "label": "(UTC+01:00) Europe, Vaduz", "value": "Europe/Vaduz" }, { "label": "(UTC+01:00) Europe, Vatican", "value": "Europe/Vatican" }, { "label": "(UTC+01:00) Europe, Vienna", "value": "Europe/Vienna" }, { "label": "(UTC+01:00) Europe, Warsaw", "value": "Europe/Warsaw" }, { "label": "(UTC+01:00) Europe, Zagreb", "value": "Europe/Zagreb" }, { "label": "(UTC+01:00) Europe, Zurich", "value": "Europe/Zurich" }, { "label": "(UTC+01:00) MET", "value": "MET" }, { "label": "(UTC+01:00) Poland", "value": "Poland" }, { "label": "(UTC+01:00) ECT", "value": "ECT" }, { "label": "(UTC+02:00) Africa, Blantyre", "value": "Africa/Blantyre" }, { "label": "(UTC+02:00) Africa, Bujumbura", "value": "Africa/Bujumbura" }, { "label": "(UTC+02:00) Africa, Cairo", "value": "Africa/Cairo" }, { "label": "(UTC+02:00) Africa, Gaborone", "value": "Africa/Gaborone" }, { "label": "(UTC+02:00) Africa, Harare", "value": "Africa/Harare" }, { "label": "(UTC+02:00) Africa, Johannesburg", "value": "Africa/Johannesburg" }, { "label": "(UTC+02:00) Africa, Khartoum", "value": "Africa/Khartoum" }, { "label": "(UTC+02:00) Africa, Kigali", "value": "Africa/Kigali" }, { "label": "(UTC+02:00) Africa, Lubumbashi", "value": "Africa/Lubumbashi" }, { "label": "(UTC+02:00) Africa, Lusaka", "value": "Africa/Lusaka" }, { "label": "(UTC+02:00) Africa, Maputo", "value": "Africa/Maputo" }, { "label": "(UTC+02:00) Africa, Maseru", "value": "Africa/Maseru" }, { "label": "(UTC+02:00) Africa, Mbabane", "value": "Africa/Mbabane" }, { "label": "(UTC+02:00) Africa, Tripoli", "value": "Africa/Tripoli" }, { "label": "(UTC+02:00) Africa, Windhoek", "value": "Africa/Windhoek" }, { "label": "(UTC+02:00) Asia, Amman", "value": "Asia/Amman" }, { "label": "(UTC+02:00) Asia, Beirut", "value": "Asia/Beirut" }, { "label": "(UTC+02:00) Asia, Damascus", "value": "Asia/Damascus" }, { "label": "(UTC+02:00) Asia, Famagusta", "value": "Asia/Famagusta" }, { "label": "(UTC+02:00) Asia, Gaza", "value": "Asia/Gaza" }, { "label": "(UTC+02:00) Asia, Hebron", "value": "Asia/Hebron" }, { "label": "(UTC+02:00) Asia, Jerusalem", "value": "Asia/Jerusalem" }, { "label": "(UTC+02:00) Asia, Nicosia", "value": "Asia/Nicosia" }, { "label": "(UTC+02:00) Asia, Tel-Aviv", "value": "Asia/Tel_Aviv" }, { "label": "(UTC+02:00) EET", "value": "EET" }, { "label": "(UTC+02:00) Egypt", "value": "Egypt" }, { "label": "(UTC+02:00) Europe, Athens", "value": "Europe/Athens" }, { "label": "(UTC+02:00) Europe, Bucharest", "value": "Europe/Bucharest" }, { "label": "(UTC+02:00) Europe, Chisinau", "value": "Europe/Chisinau" }, { "label": "(UTC+02:00) Europe, Helsinki", "value": "Europe/Helsinki" }, { "label": "(UTC+02:00) Europe, Kaliningrad", "value": "Europe/Kaliningrad" }, { "label": "(UTC+02:00) Europe, Kiev", "value": "Europe/Kiev" }, { "label": "(UTC+02:00) Europe, Mariehamn", "value": "Europe/Mariehamn" }, { "label": "(UTC+02:00) Europe, Nicosia", "value": "Europe/Nicosia" }, { "label": "(UTC+02:00) Europe, Riga", "value": "Europe/Riga" }, { "label": "(UTC+02:00) Europe, Sofia", "value": "Europe/Sofia" }, { "label": "(UTC+02:00) Europe, Tallinn", "value": "Europe/Tallinn" }, { "label": "(UTC+02:00) Europe, Tiraspol", "value": "Europe/Tiraspol" }, { "label": "(UTC+02:00) Europe, Uzhgorod", "value": "Europe/Uzhgorod" }, { "label": "(UTC+02:00) Europe, Vilnius", "value": "Europe/Vilnius" }, { "label": "(UTC+02:00) Europe, Zaporozhye", "value": "Europe/Zaporozhye" }, { "label": "(UTC+02:00) Israel", "value": "Israel" }, { "label": "(UTC+02:00) Libya", "value": "Libya" }, { "label": "(UTC+02:00) ART", "value": "ART" }, { "label": "(UTC+02:00) CAT", "value": "CAT" }, { "label": "(UTC+03:00) Africa, Addis-Ababa", "value": "Africa/Addis_Ababa" }, { "label": "(UTC+03:00) Africa, Asmara", "value": "Africa/Asmara" }, { "label": "(UTC+03:00) Africa, Asmera", "value": "Africa/Asmera" }, { "label": "(UTC+03:00) Africa, Dar-es-Salaam", "value": "Africa/Dar_es_Salaam" }, { "label": "(UTC+03:00) Africa, Djibouti", "value": "Africa/Djibouti" }, { "label": "(UTC+03:00) Africa, Juba", "value": "Africa/Juba" }, { "label": "(UTC+03:00) Africa, Kampala", "value": "Africa/Kampala" }, { "label": "(UTC+03:00) Africa, Mogadishu", "value": "Africa/Mogadishu" }, { "label": "(UTC+03:00) Africa, Nairobi", "value": "Africa/Nairobi" }, { "label": "(UTC+03:00) Antarctica, Syowa", "value": "Antarctica/Syowa" }, { "label": "(UTC+03:00) Asia, Aden", "value": "Asia/Aden" }, { "label": "(UTC+03:00) Asia, Baghdad", "value": "Asia/Baghdad" }, { "label": "(UTC+03:00) Asia, Bahrain", "value": "Asia/Bahrain" }, { "label": "(UTC+03:00) Asia, Istanbul", "value": "Asia/Istanbul" }, { "label": "(UTC+03:00) Asia, Kuwait", "value": "Asia/Kuwait" }, { "label": "(UTC+03:00) Asia, Qatar", "value": "Asia/Qatar" }, { "label": "(UTC+03:00) Asia, Riyadh", "value": "Asia/Riyadh" }, { "label": "(UTC+03:00) Europe, Istanbul", "value": "Europe/Istanbul" }, { "label": "(UTC+03:00) Europe, Kirov", "value": "Europe/Kirov" }, { "label": "(UTC+03:00) Europe, Minsk", "value": "Europe/Minsk" }, { "label": "(UTC+03:00) Europe, Moscow", "value": "Europe/Moscow" }, { "label": "(UTC+03:00) Europe, Simferopol", "value": "Europe/Simferopol" }, { "label": "(UTC+03:00) Indian, Antananarivo", "value": "Indian/Antananarivo" }, { "label": "(UTC+03:00) Indian, Comoro", "value": "Indian/Comoro" }, { "label": "(UTC+03:00) Indian, Mayotte", "value": "Indian/Mayotte" }, { "label": "(UTC+03:00) Turkey", "value": "Turkey" }, { "label": "(UTC+03:00) W-SU", "value": "W-SU" }, { "label": "(UTC+03:00) EAT", "value": "EAT" }, { "label": "(UTC+03:30) Asia, Tehran", "value": "Asia/Tehran" }, { "label": "(UTC+03:30) Iran", "value": "Iran" }, { "label": "(UTC+04:00) Asia, Baku", "value": "Asia/Baku" }, { "label": "(UTC+04:00) Asia, Dubai", "value": "Asia/Dubai" }, { "label": "(UTC+04:00) Asia, Muscat", "value": "Asia/Muscat" }, { "label": "(UTC+04:00) Asia, Tbilisi", "value": "Asia/Tbilisi" }, { "label": "(UTC+04:00) Asia, Yerevan", "value": "Asia/Yerevan" }, { "label": "(UTC+04:00) Europe, Astrakhan", "value": "Europe/Astrakhan" }, { "label": "(UTC+04:00) Europe, Samara", "value": "Europe/Samara" }, { "label": "(UTC+04:00) Europe, Saratov", "value": "Europe/Saratov" }, { "label": "(UTC+04:00) Europe, Ulyanovsk", "value": "Europe/Ulyanovsk" }, { "label": "(UTC+04:00) Europe, Volgograd", "value": "Europe/Volgograd" }, { "label": "(UTC+04:00) Indian, Mahe", "value": "Indian/Mahe" }, { "label": "(UTC+04:00) Indian, Mauritius", "value": "Indian/Mauritius" }, { "label": "(UTC+04:00) Indian, Reunion", "value": "Indian/Reunion" }, { "label": "(UTC+04:00) NET", "value": "NET" }, { "label": "(UTC+04:30) Asia, Kabul", "value": "Asia/Kabul" }, { "label": "(UTC+05:00) Antarctica, Mawson", "value": "Antarctica/Mawson" }, { "label": "(UTC+05:00) Asia, Aqtau", "value": "Asia/Aqtau" }, { "label": "(UTC+05:00) Asia, Aqtobe", "value": "Asia/Aqtobe" }, { "label": "(UTC+05:00) Asia, Ashgabat", "value": "Asia/Ashgabat" }, { "label": "(UTC+05:00) Asia, Ashkhabad", "value": "Asia/Ashkhabad" }, { "label": "(UTC+05:00) Asia, Atyrau", "value": "Asia/Atyrau" }, { "label": "(UTC+05:00) Asia, Dushanbe", "value": "Asia/Dushanbe" }, { "label": "(UTC+05:00) Asia, Karachi", "value": "Asia/Karachi" }, { "label": "(UTC+05:00) Asia, Oral", "value": "Asia/Oral" }, { "label": "(UTC+05:00) Asia, Samarkand", "value": "Asia/Samarkand" }, { "label": "(UTC+05:00) Asia, Tashkent", "value": "Asia/Tashkent" }, { "label": "(UTC+05:00) Asia, Yekaterinburg", "value": "Asia/Yekaterinburg" }, { "label": "(UTC+05:00) Indian, Kerguelen", "value": "Indian/Kerguelen" }, { "label": "(UTC+05:00) Indian, Maldives", "value": "Indian/Maldives" }, { "label": "(UTC+05:00) PLT", "value": "PLT" }, { "label": "(UTC+05:30) Asia, Calcutta", "value": "Asia/Calcutta" }, { "label": "(UTC+05:30) Asia, Colombo", "value": "Asia/Colombo" }, { "label": "(UTC+05:30) Asia, Kolkata", "value": "Asia/Kolkata" }, { "label": "(UTC+05:30) IST", "value": "IST" }, { "label": "(UTC+05:45) Asia, Kathmandu", "value": "Asia/Kathmandu" }, { "label": "(UTC+05:45) Asia, Katmandu", "value": "Asia/Katmandu" }, { "label": "(UTC+06:00) Antarctica, Vostok", "value": "Antarctica/Vostok" }, { "label": "(UTC+06:00) Asia, Almaty", "value": "Asia/Almaty" }, { "label": "(UTC+06:00) Asia, Bishkek", "value": "Asia/Bishkek" }, { "label": "(UTC+06:00) Asia, Dacca", "value": "Asia/Dacca" }, { "label": "(UTC+06:00) Asia, Dhaka", "value": "Asia/Dhaka" }, { "label": "(UTC+06:00) Asia, Kashgar", "value": "Asia/Kashgar" }, { "label": "(UTC+06:00) Asia, Omsk", "value": "Asia/Omsk" }, { "label": "(UTC+06:00) Asia, Qyzylorda", "value": "Asia/Qyzylorda" }, { "label": "(UTC+06:00) Asia, Thimbu", "value": "Asia/Thimbu" }, { "label": "(UTC+06:00) Asia, Thimphu", "value": "Asia/Thimphu" }, { "label": "(UTC+06:00) Asia, Urumqi", "value": "Asia/Urumqi" }, { "label": "(UTC+06:00) Indian, Chagos", "value": "Indian/Chagos" }, { "label": "(UTC+06:00) BST", "value": "BST" }, { "label": "(UTC+06:30) Asia, Rangoon", "value": "Asia/Rangoon" }, { "label": "(UTC+06:30) Asia, Yangon", "value": "Asia/Yangon" }, { "label": "(UTC+06:30) Indian, Cocos", "value": "Indian/Cocos" }, { "label": "(UTC+07:00) Antarctica, Davis", "value": "Antarctica/Davis" }, { "label": "(UTC+07:00) Asia, Bangkok", "value": "Asia/Bangkok" }, { "label": "(UTC+07:00) Asia, Barnaul", "value": "Asia/Barnaul" }, { "label": "(UTC+07:00) Asia, Ho-Chi-Minh", "value": "Asia/Ho_Chi_Minh" }, { "label": "(UTC+07:00) Asia, Hovd", "value": "Asia/Hovd" }, { "label": "(UTC+07:00) Asia, Jakarta", "value": "Asia/Jakarta" }, { "label": "(UTC+07:00) Asia, Krasnoyarsk", "value": "Asia/Krasnoyarsk" }, { "label": "(UTC+07:00) Asia, Novokuznetsk", "value": "Asia/Novokuznetsk" }, { "label": "(UTC+07:00) Asia, Novosibirsk", "value": "Asia/Novosibirsk" }, { "label": "(UTC+07:00) Asia, Phnom-Penh", "value": "Asia/Phnom_Penh" }, { "label": "(UTC+07:00) Asia, Pontianak", "value": "Asia/Pontianak" }, { "label": "(UTC+07:00) Asia, Saigon", "value": "Asia/Saigon" }, { "label": "(UTC+07:00) Asia, Tomsk", "value": "Asia/Tomsk" }, { "label": "(UTC+07:00) Asia, Vientiane", "value": "Asia/Vientiane" }, { "label": "(UTC+07:00) Indian, Christmas", "value": "Indian/Christmas" }, { "label": "(UTC+07:00) VST", "value": "VST" }, { "label": "(UTC+08:00) Antarctica, Casey", "value": "Antarctica/Casey" }, { "label": "(UTC+08:00) Asia, Brunei", "value": "Asia/Brunei" }, { "label": "(UTC+08:00) Asia, Choibalsan", "value": "Asia/Choibalsan" }, { "label": "(UTC+08:00) Asia, Chongqing", "value": "Asia/Chongqing" }, { "label": "(UTC+08:00) Asia, Chungking", "value": "Asia/Chungking" }, { "label": "(UTC+08:00) Asia, Harbin", "value": "Asia/Harbin" }, { "label": "(UTC+08:00) Asia, Hong-Kong", "value": "Asia/Hong_Kong" }, { "label": "(UTC+08:00) Asia, Irkutsk", "value": "Asia/Irkutsk" }, { "label": "(UTC+08:00) Asia, Kuala-Lumpur", "value": "Asia/Kuala_Lumpur" }, { "label": "(UTC+08:00) Asia, Kuching", "value": "Asia/Kuching" }, { "label": "(UTC+08:00) Asia, Macao", "value": "Asia/Macao" }, { "label": "(UTC+08:00) Asia, Macau", "value": "Asia/Macau" }, { "label": "(UTC+08:00) Asia, Makassar", "value": "Asia/Makassar" }, { "label": "(UTC+08:00) Asia, Manila", "value": "Asia/Manila" }, { "label": "(UTC+08:00) Asia, Shanghai", "value": "Asia/Shanghai" }, { "label": "(UTC+08:00) Asia, Singapore", "value": "Asia/Singapore" }, { "label": "(UTC+08:00) Asia, Taipei", "value": "Asia/Taipei" }, { "label": "(UTC+08:00) Asia, Ujung-Pandang", "value": "Asia/Ujung_Pandang" }, { "label": "(UTC+08:00) Asia, Ulaanbaatar", "value": "Asia/Ulaanbaatar" }, { "label": "(UTC+08:00) Asia, Ulan-Bator", "value": "Asia/Ulan_Bator" }, { "label": "(UTC+08:00) Australia, Perth", "value": "Australia/Perth" }, { "label": "(UTC+08:00) Australia, West", "value": "Australia/West" }, { "label": "(UTC+08:00) Hongkong", "value": "Hongkong" }, { "label": "(UTC+08:00) PRC", "value": "PRC" }, { "label": "(UTC+08:00) Singapore", "value": "Singapore" }, { "label": "(UTC+08:00) CTT", "value": "CTT" }, { "label": "(UTC+08:45) Australia, Eucla", "value": "Australia/Eucla" }, { "label": "(UTC+09:00) Asia, Chita", "value": "Asia/Chita" }, { "label": "(UTC+09:00) Asia, Dili", "value": "Asia/Dili" }, { "label": "(UTC+09:00) Asia, Jayapura", "value": "Asia/Jayapura" }, { "label": "(UTC+09:00) Asia, Khandyga", "value": "Asia/Khandyga" }, { "label": "(UTC+09:00) Asia, Pyongyang", "value": "Asia/Pyongyang" }, { "label": "(UTC+09:00) Asia, Seoul", "value": "Asia/Seoul" }, { "label": "(UTC+09:00) Asia, Tokyo", "value": "Asia/Tokyo" }, { "label": "(UTC+09:00) Asia, Yakutsk", "value": "Asia/Yakutsk" }, { "label": "(UTC+09:00) Japan", "value": "Japan" }, { "label": "(UTC+09:00) Pacific, Palau", "value": "Pacific/Palau" }, { "label": "(UTC+09:00) ROK", "value": "ROK" }, { "label": "(UTC+09:00) JST", "value": "JST" }, { "label": "(UTC+10:30) Australia, Adelaide", "value": "Australia/Adelaide" }, { "label": "(UTC+10:30) Australia, Broken-Hill", "value": "Australia/Broken_Hill" }, { "label": "(UTC+09:30) Australia, Darwin", "value": "Australia/Darwin" }, { "label": "(UTC+09:30) Australia, North", "value": "Australia/North" }, { "label": "(UTC+10:30) Australia, South", "value": "Australia/South" }, { "label": "(UTC+10:30) Australia, Yancowinna", "value": "Australia/Yancowinna" }, { "label": "(UTC+09:30) ACT", "value": "ACT" }, { "label": "(UTC+10:00) Antarctica, DumontDUrville", "value": "Antarctica/DumontDUrville" }, { "label": "(UTC+10:00) Asia, Ust-Nera", "value": "Asia/Ust-Nera" }, { "label": "(UTC+10:00) Asia, Vladivostok", "value": "Asia/Vladivostok" }, { "label": "(UTC+11:00) Australia, ACT", "value": "Australia/ACT" }, { "label": "(UTC+10:00) Australia, Brisbane", "value": "Australia/Brisbane" }, { "label": "(UTC+11:00) Australia, Canberra", "value": "Australia/Canberra" }, { "label": "(UTC+11:00) Australia, Currie", "value": "Australia/Currie" }, { "label": "(UTC+11:00) Australia, Hobart", "value": "Australia/Hobart" }, { "label": "(UTC+10:00) Australia, Lindeman", "value": "Australia/Lindeman" }, { "label": "(UTC+11:00) Australia, Melbourne", "value": "Australia/Melbourne" }, { "label": "(UTC+11:00) Australia, NSW", "value": "Australia/NSW" }, { "label": "(UTC+10:00) Australia, Queensland", "value": "Australia/Queensland" }, { "label": "(UTC+11:00) Australia, Sydney", "value": "Australia/Sydney" }, { "label": "(UTC+11:00) Australia, Tasmania", "value": "Australia/Tasmania" }, { "label": "(UTC+11:00) Australia, Victoria", "value": "Australia/Victoria" }, { "label": "(UTC+10:00) Pacific, Chuuk", "value": "Pacific/Chuuk" }, { "label": "(UTC+10:00) Pacific, Guam", "value": "Pacific/Guam" }, { "label": "(UTC+10:00) Pacific, Port-Moresby", "value": "Pacific/Port_Moresby" }, { "label": "(UTC+10:00) Pacific, Saipan", "value": "Pacific/Saipan" }, { "label": "(UTC+10:00) Pacific, Truk", "value": "Pacific/Truk" }, { "label": "(UTC+10:00) Pacific, Yap", "value": "Pacific/Yap" }, { "label": "(UTC+11:00) AET", "value": "AET" }, { "label": "(UTC+11:00) Australia, LHI", "value": "Australia/LHI" }, { "label": "(UTC+11:00) Australia, Lord-Howe", "value": "Australia/Lord_Howe" }, { "label": "(UTC+11:00) Antarctica, Macquarie", "value": "Antarctica/Macquarie" }, { "label": "(UTC+11:00) Asia, Magadan", "value": "Asia/Magadan" }, { "label": "(UTC+11:00) Asia, Sakhalin", "value": "Asia/Sakhalin" }, { "label": "(UTC+11:00) Asia, Srednekolymsk", "value": "Asia/Srednekolymsk" }, { "label": "(UTC+11:00) Pacific, Bougainville", "value": "Pacific/Bougainville" }, { "label": "(UTC+11:00) Pacific, Efate", "value": "Pacific/Efate" }, { "label": "(UTC+11:00) Pacific, Guadalcanal", "value": "Pacific/Guadalcanal" }, { "label": "(UTC+11:00) Pacific, Kosrae", "value": "Pacific/Kosrae" }, { "label": "(UTC+11:00) Pacific, Norfolk", "value": "Pacific/Norfolk" }, { "label": "(UTC+11:00) Pacific, Noumea", "value": "Pacific/Noumea" }, { "label": "(UTC+11:00) Pacific, Pohnpei", "value": "Pacific/Pohnpei" }, { "label": "(UTC+11:00) Pacific, Ponape", "value": "Pacific/Ponape" }, { "label": "(UTC+11:00) SST", "value": "SST" }, { "label": "(UTC+13:00) Antarctica, McMurdo", "value": "Antarctica/McMurdo" }, { "label": "(UTC+13:00) Antarctica, South-Pole", "value": "Antarctica/South_Pole" }, { "label": "(UTC+12:00) Asia, Anadyr", "value": "Asia/Anadyr" }, { "label": "(UTC+12:00) Asia, Kamchatka", "value": "Asia/Kamchatka" }, { "label": "(UTC+12:00) Kwajalein", "value": "Kwajalein" }, { "label": "(UTC+13:00) NZ", "value": "NZ" }, { "label": "(UTC+13:00) Pacific, Auckland", "value": "Pacific/Auckland" }, { "label": "(UTC+12:00) Pacific, Fiji", "value": "Pacific/Fiji" }, { "label": "(UTC+12:00) Pacific, Funafuti", "value": "Pacific/Funafuti" }, { "label": "(UTC+12:00) Pacific, Kwajalein", "value": "Pacific/Kwajalein" }, { "label": "(UTC+12:00) Pacific, Majuro", "value": "Pacific/Majuro" }, { "label": "(UTC+12:00) Pacific, Nauru", "value": "Pacific/Nauru" }, { "label": "(UTC+12:00) Pacific, Tarawa", "value": "Pacific/Tarawa" }, { "label": "(UTC+12:00) Pacific, Wake", "value": "Pacific/Wake" }, { "label": "(UTC+12:00) Pacific, Wallis", "value": "Pacific/Wallis" }, { "label": "(UTC+13:00) NST", "value": "NST" }, { "label": "(UTC+13:45) NZ-CHAT", "value": "NZ-CHAT" }, { "label": "(UTC+13:45) Pacific, Chatham", "value": "Pacific/Chatham" }, { "label": "(UTC+14:00) Pacific, Apia", "value": "Pacific/Apia" }, { "label": "(UTC+13:00) Pacific, Enderbury", "value": "Pacific/Enderbury" }, { "label": "(UTC+13:00) Pacific, Fakaofo", "value": "Pacific/Fakaofo" }, { "label": "(UTC+13:00) Pacific, Tongatapu", "value": "Pacific/Tongatapu" }, { "label": "(UTC+14:00) MIT", "value": "MIT" }, { "label": "(UTC+14:00) Pacific, Kiritimati", "value": "Pacific/Kiritimati" }]

